<template>
    <div class="material-wear-house">
        <div class="top">
            <div class="tabs">
                <div v-for="(item,index) in tab_list" :key="`tab-${index}`" :class="['tab-item',{active:item.value == query_form.type}]" @click="onTabClick(item.value)">{{item.title}}</div>
            </div>
            <div class="top-right">
                <div class="search-box">
                    <input v-model="query_form.keyword" placeholder="搜索关键词搜索" type="text" @keyup.enter="onSearch" />
                    <img src="../../assets/images/icon-search-workbench.png" @click="onSearch" />
                </div>
                <div class="add-material" v-if="query_form.type != 'history'" @click="onAddMaterial">
                    <Icon type="md-add" color="#ffffff" />添加{{ query_form.type == 'fabric' ? '面料' : '辅料' }}
                </div>
            </div>
        </div>
        <div class="content">
            <template v-if="query_form.type != 'history'">
                <Spin fix v-if="is_loading">
                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                    <div>Loading</div>
                </Spin>
                <!-- 缺省 -->
                <div class="empty-data" v-if="!list.length">
                    <img src="../../assets/images/no-data.png" class="no-data" alt="">
                    <p style="margin-top:26px;">还在为找面辅料浪费时间?自己库存混乱、盘点繁琐?入仓后,全链路数字化,让管理一目了然,定制时直接调用,告别反复寄样</p>
                    <p>快去搭建属于你的专属面辅料库吧!</p>
                    <div class="material-add-btn" @click="onAddMaterial">
                        <Icon type="md-add" color="#ff5967" />添加{{ query_form.type == 'fabric' ? '面料' : '辅料' }}
                    </div>
                </div>
                <!-- 列表TAB -->
                <template v-else>
                    <div class="list-tab">
                        <div v-for="(item,index) in tabs_list" :key="`tab-list-${index}`" :class="['list-tab-item',{active:query_form.list_type == item.value}]" @click="query_form.list_type = item.value">{{ item.title }}{{ item.show_count ? `(${item.count})` : '' }}</div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th class="info-col" title="面料信息">面料信息</th>
                                <th class="width-col" title="幅宽(cm)">幅宽(cm)</th>
                                <template v-if="query_form.type == 'fabric'">
                                    <th class="weight-col" title="克重(g/㎡)">克重(g/㎡)</th>
                                    <th class="color-col" title="颜色">颜色</th>
                                </template>
                                <th v-if="query_form.type == 'fabric'" class="stock-col" title="库存数量(m)">库存数量(m)</th>
                                <th v-else class="stock-col">库存数量</th>
                                <th class="status-col" title="状态">状态</th>
                                <th class="action-col" title="操作">操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in list" :key="`tb-index-${index}`" @click="onDetailClick(item)">
                                <td class="info-body-col">
                                    <img :src="item.image|default_img" alt="" class="cover-img" />
                                    <div class="info">
                                        <div class="title">{{item.name}}</div>
                                        <div class="info-item">编号:{{item.no}}</div>
                                        <div class="info-item">成分:{{item.component}}</div>
                                    </div>
                                </td>
                                <template v-if="query_form.type == 'fabric'">
                                    <td>{{item.wide_width}}</td>
                                    <td>{{item.weight}}</td>
                                </template>
                                <td>{{item.color_text}}</td>
                                <td>
                                    <template v-if="!item.total_stock">-</template>
                                    <template v-else>
                                        <div class="stock-num-col">
                                            <div class="num">{{item.total_stock}}</div>
                                            <div class="detail-btn" @click.stop="onStockDetail(item)">详情</div>
                                        </div>
                                    </template>
                                </td>
                                    <td :class="['status-body-col',{'status-success':item.warehouse_status}]">{{ item.warehouse_status ? '已入仓' : '未入仓' }}</td>
                                <td>
                                    <div class="info-action-col">
                                        <img src="../../assets/images/material-wear-house/icon-edit.png" alt="" class="edit-icon" @click.stop="onEditMaterial(item)" />
                                        <img src="../../assets/images/material-wear-house/icon-delete.png" alt="" class="delete-icon" @click.stop="onDeleteMaterial(item.uuid)" />
                                        <div class="add-btn" @click.stop="onFabricIn(item)">入仓</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </template>
            <!-- 历史记录 -->
            <template v-else>
                <Spin fix v-if="history_loading">
                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                    <div>Loading</div>
                </Spin>
                <div class="history-container">
                    <div class="history-tag-box">
                        <div class="history-tab">
                            <div
                                :class="['tag-item', { active: current_history_type == -1 }]"
                                @click="onChangeHistoryType(-1)"
                            >
                                全部
                            </div>
                            <div
                                :class="['tag-item', { active: current_history_type == 1 }]"
                                @click="onChangeHistoryType(1)"
                            >
                                平台面料
                            </div>
                            <div
                                :class="['tag-item', { active: current_history_type == 2 }]"
                                @click="onChangeHistoryType(2)"
                            >
                                平台辅料
                            </div>
                            <div
                                :class="['tag-item', { active: current_history_type == 3 }]"
                                @click="onChangeHistoryType(3)"
                            >
                                自己提供面料
                            </div>
                            <div
                                :class="['tag-item', { active: current_history_type == 4 }]"
                                @click="onChangeHistoryType(4)"
                            >
                                自己提供辅料
                            </div>
                        </div>
                    </div>
                    <div class="empty-data" v-if="!history_list.length && !history_loading">
                        <img src="../../assets/images/no-data.png" class="no-data" alt="">
                        <p style="margin-top:26px;">暂无历史记录</p>
                    </div>
                    <template v-else-if="history_list.length">
                        <table class="history-table" align="center">
                            <thead>
                                <tr>
                                    <th>面辅料信息</th>
                                    <th>类型</th>
                                    <th>订单信息</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in history_list" :key="index">
                                    <td>
                                        <div class="info-box">
                                            <img
                                                :src="item.cover_img | default_img"
                                                alt=""
                                                class="cover-img"
                                            />
                                            <div class="info">
                                                <div class="info-title">
                                                    {{ item.name || "-" }}
                                                    <span
                                                        v-if="item.type"
                                                        :class="[
                                                            'title-tag',
                                                            {
                                                                platform: item.type == 1,
                                                                custom: item.type == 3,
                                                            },
                                                        ]"
                                                    >[{{ item.history_type == 'fabric' ? '面料' : '辅料' }}]</span>
                                                </div>
                                                <div class="info-key">
                                                    编号:{{ item.key || "-" }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span
                                            :class="[
                                                'type-tag',
                                                {
                                                    platform: item.type == 1,
                                                    custom: item.type == 3,
                                                },
                                            ]"
                                        >{{ item.type == 1 ? '平台' : '客供' }}{{ item.history_type == 'fabric' ? '面料' : '辅料' }}</span>
                                    </td>
                                    <td style="display: flex;justify-content: center;width: 100%;">
                                        <div style="text-align: left; width: fit-content">
                                            <p><span>订单编号:</span>{{ item.order_no }}</p>
                                            <p><span>使用款号:</span>{{ item.style_number || "-" }}</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <Page
                            :current="form_data_history.page"
                            v-if="history_total > 0"
                            :page-size="form_data_history.size"
                            :total="history_total"
                            @on-change="onChangeHistoryPage"
                            show-total
                            class="history-page"
                        ></Page>
                    </template>
                </div>
            </template>
        </div>
        <stock-detail v-if="show_stock_detail" :material="curr_material" @close="onClose" />
        <add-material v-if="show_add_material" @close="onClose" :material="curr_material" :type="query_form.type == 'fabric' ? '1' : '2'" />
        <material-in v-if="show_material_in" @close="onClose" :material="curr_material" />
    </div>
</template>
<script>
import { DeleteOwnerMaterial, GetOwnerMaterialCount, GetOwnerMaterialList, getDesignHistory } from '@/api/index';
import AddMaterial from './components/AddMaterial.vue';
import MaterialIn from './components/MaterialIn.vue';
import StockDetail from './components/StockDetail.vue';
export default{
    components:{
        StockDetail,AddMaterial,MaterialIn
    },
    data(){
        return{
            tab_list:[
                {title:'我的面料库',value:'fabric'},
                {title:'我的辅料库',value:'accessory'},
                {title:'历史记录',value:'history'}
            ],
            tabs_list:[
                {title:'全部',show_count:false,value:'all'},
                {title:'未入仓',show_count:true,count:0,value:'un-in'},
                {title:'已入仓',show_count:true,count:0,value:'in'}
            ],
            query_form:{
                keyword:'',
                type:'fabric',
                list_type:'all',
                page:1,
                limit:10
            },
            list:[],
            show_stock_detail:false,
            show_add_material:false,
            show_material_in:false,
            curr_material:{},
            is_loading:false,
            current_history_type:-1,
            form_data_history:{
                page:1,
                size:20,
                keyword:'',
                type:'fabric',
                is_self:false,
                is_all:true
            },
            history_list:[],
            history_total:-1,
            history_type:'fabric',
            history_loading:false
        }
    },
    watch:{
        'query_form.type':{
            handler(news,olds){
                console.log('news-type',news);
                if(news == 'history'){
                    this.onGetHistoryList(true);
                }else{
                    this.query_form.list_type = 'all';
                    this.onGetList();
                }
            }
        },
        'query_form.list_type':{
            handler(news,olds){
                console.log('news-list_type',news);
                if(this.query_form.type != 'history'){
                    this.onGetList();
                }
            }
        },
        'current_history_type':{
            handler(news,olds){
                this.form_data_history.is_self = news == 4 || news == 3;
                this.form_data_history.is_all = news == -1;
                if(news == 1){
                    this.history_type = 'fabric';
                }else if(news == 2){
                    this.history_type = 'accessory';
                }
                this.onGetHistoryList(true);
            }
        }
    },
    mounted(){
        if(this.$route.query.type){
            this.query_form.type = this.$route.query.type;
        }
        if(this.query_form.type == 'history'){
            this.onGetHistoryList(true);
        }else{
            this.onGetList();
        }
    },
    methods:{
        onTabClick(value){
            // query_form.type = item.value
            this.query_form.type = value;
            this.$router.push({name:'MaterialWearHouse',query:{type:value}});
        },
        onStockDetail(item){
            this.curr_material = item;
            this.show_stock_detail = true;
        },
        onDetailClick({uuid}){
            this.$router.push({name:'MaterialWearHouseDetail',query:{uuid,type:this.query_form.type}})
        },
        async onDeleteMaterial(uuid){
            try{
                const {code,msg} = await DeleteOwnerMaterial({uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.onGetList();
            }catch(e){
                console.log('err-delete-material',e);
                this.$layer.msg(e.msg);
            }
        },
        onClose(){
            const {show_add_material,show_material_in,show_stock_detail,curr_material} = this;
            if(show_add_material) this.show_add_material = !show_add_material;
            if(show_material_in) this.show_material_in = !show_material_in;
            if(show_stock_detail) this.show_stock_detail = !show_stock_detail;
            if(curr_material) this.curr_material = {};
            this.onGetList();
        },
        onFabricIn(material){
            this.curr_material = material;
            this.show_material_in = true;
        },
        onEditMaterial(material){
            this.curr_material = material;
            this.show_add_material = true;
        },
        async onGetList(){
            try{
                this.is_loading = true;
                let status,type;
                switch(this.query_form.list_type){
                    case 'un-in':
                        status = 0;
                        break;
                    case 'in':
                        status = 1;
                        break;
                    default:
                        status = 99;
                        break;
                }
                switch(this.query_form.type){
                    case 'accessory':
                        type = 2;
                        break;
                    default:
                        type = 1;
                        break;
                }
                const {code:code_count,msg:msg_count,data:data_count} = await GetOwnerMaterialCount({type});
                if(code_count>0){
                    this.$layer.msg(msg_count);                    
                }
                this.tabs_list.forEach(item=>{
                    switch(item.value){
                        case 'un-in':
                            item.count = data_count.no_in_stock;
                            break;
                        case 'in':
                            item.count = data_count.yes_in_stock;
                            break;
                    }
                })
                const {code,msg,data} = await GetOwnerMaterialList({...this.query_form,status,type});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.list = data.list;
                console.log('data',data);
            }catch(e){
                console.log('err-on-get-list',e);
                this.$layer.msg(e.msg);
            }finally{
                this.is_loading = false;
            }
        },
        
        //>添加面料/辅料
        onAddMaterial(){
            this.show_add_material = true;
        },
        //>搜索
        onSearch(){
            if(this.query_form.type == 'history'){
                this.onGetHistoryList(true);
            }else{
                this.onGetList();
            }
        },
        async onGetHistoryList(is_search = false){
            try{
                if(is_search){
                    this.form_data_history.page = 1;
                }
                this.history_loading = true;
                this.form_data_history.keyword = this.query_form.keyword;
                let params = {...this.form_data_history};
                if(this.current_history_type == -1){
                    params.type = this.history_type;
                }else if(this.current_history_type == 1){
                    params.type = 'fabric';
                }else if(this.current_history_type == 2){
                    params.type = 'accessory';
                }else if(this.current_history_type == 3){
                    params.type = 'fabric';
                }else if(this.current_history_type == 4){
                    params.type = 'accessory';
                }
                let all_list = [];
                let total = 0;
                if(this.current_history_type == -1){
                    const fabric_params = {...params, type:'fabric'};
                    const accessory_params = {...params, type:'accessory'};
                    const {data:fabric_data} = await getDesignHistory(fabric_params);
                    const {data:accessory_data} = await getDesignHistory(accessory_params);
                    all_list = [
                        ...(fabric_data.list || []).map(item=>({...item, history_type:'fabric'})),
                        ...(accessory_data.list || []).map(item=>({...item, history_type:'accessory'}))
                    ];
                    total = (fabric_data.total || 0) + (accessory_data.total || 0);
                }else{
                    const {data} = await getDesignHistory(params);
                    all_list = (data.list || []).map(item=>({
                        ...item, 
                        history_type: this.current_history_type == 1 || this.current_history_type == 3 ? 'fabric' : 'accessory'
                    }));
                    total = data.total || 0;
                }
                this.history_list = all_list;
                this.history_total = total;
                console.log('history_list', this.history_list);
            }catch(e){
                console.log('err-on-get-history-list',e);
                this.$layer.msg(e.msg);
            }finally{
                this.history_loading = false;
            }
        },
        onChangeHistoryType(type){
            this.current_history_type = type;
        },
        onChangeHistoryPage(page){
            this.form_data_history.page = page;
            this.onGetHistoryList();
        }
    }
}
</script>
<style lang="scss" scoped>
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}
.material-wear-house{
    width: 100%;
    min-height:calc(100vh - 80px);
    padding: 20px 20px 180px 30px;
    background:#ffffff;
    .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        border-bottom: 1px solid #d6d6d6;
        padding-bottom: 10px;
        position: relative;
        z-index: 1;

        .tabs {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .tab-item {
                cursor: pointer;
                color: #666666;
                font-size: 18px;
                margin-right: 50px;
                position: relative;
                z-index: 2;

                &.active {
                    color: #000000;
                    font-weight: bold;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: -22px;
                        width: 100%;
                        height: 3px;
                        background: #ff5967;
                        z-index: 3;
                        pointer-events: none;
                    }
                }
            }

            .tab-item.active {
                border-bottom: none !important;
            }
        }
        .top-right{
            display:flex;
            align-items:center;
            column-gap: 28px;
            .search-box {
                background: #f3f4f6;
                border-radius: 25px;
                width: 300px;
                height: 50px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                input {
                    flex: 1;
                    border: none;
                    outline: none;
                    background: transparent;
                    padding-left: 20px;
                }

                img {
                    width: 21px;
                    height: 21px;
                    margin-right: 20px;
                    cursor: pointer;
                }
            }
            .add-material{
                background:#ff5967;
                color:#fff;
                border-radius:4px;
                display:flex;
                align-items:center;
                justify-content:center;
                column-gap:12px;
                font-size:14px;
                font-weight:bold;
                padding:8px 20px;
                cursor:pointer;
            }
        }
    }
    .content{
        width:100%;
        display:flex;
        justify-content:center;
        flex-direction:column;
        position:relative;
        .empty-data{
            display:flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            .no-data{
                width:300px;
                display: block;
                margin-top:46px;
            }
            p{
              line-height:28px;
            }
            .material-add-btn{
                border:1px solid #ff5967;
                border-radius:4px;
                color:#ff5967;
                display:flex;
                align-items:center;
                justify-content:center;
                column-gap:8px;
                padding:9px 34px;
                margin-top:41px;
                cursor:pointer;
            }
        }
        .list-tab{
            display:flex;
            align-items:center;
            column-gap:20px;
            margin-top:24px;
            width:100%;
            .list-tab-item{
                color:#666;
                font-size:14px;
                cursor:pointer;
                &.active{
                    color:#fff;
                    background:#ff5967;
                    line-height:32px;
                    border-radius:4px;
                    padding:0 12px;
                }
            }
        }
        table{
            table-layout:fixed;
            border-collapse: separate;
            width:100%;
            border-spacing: 0 10px;
            margin-top:22px;
            thead{
                tr{
                    background:#f6f7fa;
                    th{
                        text-align:center;
                        color:#666;
                        line-height:32px;
                        padding:10px 20px;
                        font-size:14px;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                        &.info-col{
                            width:352px;
                        }
                        &.width-col,&.weight-col{ 
                            width:100px;
                        }
                        &.color-col{
                            width:220px;
                        }
                        &.stock-col{
                            width:180px;
                        }
                        &.status-col{
                            width:140px;
                        }
                        &.action-col{
                            width:194px;
                            padding-right:0;
                        }
                    }
                }
            }
            tbody{
                tr{
                    border-radius:10px;
                    box-shadow:0 0 0 1px #ebedf2; 
                    &:hover{
                        background:#f8f9fb;
                    }
                    td{
                        text-align:center;
                        &.info-body-col{
                            width:100%;
                            display:flex;
                            align-items:center;
                            column-gap:16px;
                            padding:16px 20px;
                            .cover-img{
                                width:96px;
                                height:96px;
                                object-fit:cover;
                                object-position:center;
                            }
                            .info{
                                display:flex;
                                flex-direction:column;
                                align-items:flex-start;
                                width:100%;
                                .title{
                                    color:#333;
                                    font-size:14px;
                                    font-weight:bold;
                                    white-space:nowrap;
                                    overflow:hidden;
                                    text-overflow:ellipsis;
                                    margin-bottom:10px;
                                }
                                .info-item{
                                    color:#666;
                                    font-size:14px;
                                    white-space:nowrap;
                                    overflow:hidden;
                                    text-overflow:ellipsis;
                                }
                            }
                        }
                        &.status-body-col{
                            color:#666;
                            &.status-success{
                                color:#02c160;
                            }
                        }
                        .info-action-col{
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            column-gap:16px;
                            height:100%;
                            width:100%;
                            .edit-icon,.delete-icon{
                                width:22px;
                                height:22px;
                                cursor:pointer;
                            }
                            .add-btn{
                                background:#ff5967;
                                color:#fff;
                                font-size:14px;
                                padding:6px 26px;
                                border-radius:4px;
                                cursor:pointer;
                            }
                        }
                        .stock-num-col{
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            column-gap:10px;
                            .num{
                                color:#333;
                                font-size:14px;
                            }
                            .detail-btn{
                                color:#0d99ff;
                                font-size:12px;
                                cursor:pointer;
                            }
                        }
                    }
                }
            }
        }
        .history-container{
            width:100%;
            .history-tag-box{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;
                margin-top: 13px;
                .history-tab{
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    .tag-item{
                        color: #4d4d4d;
                        font-size: 14px;
                        padding: 9px 16px;
                        cursor: pointer;
                        &.active{
                            color: #fb486d;
                            font-weight: bold;
                            border-radius: 24px;
                            background: rgba(251, 72, 109, 0.1);
                        }
                    }
                }
            }
            .history-table{
                table-layout:fixed;
                border-collapse: separate;
                width:100%;
                border-spacing: 0 10px;
                margin-top:22px;
                thead{
                    tr{
                        background:#f6f7fa;
                        th{
                            text-align:center;
                            color:#666;
                            line-height:32px;
                            padding:10px 20px;
                            font-size:14px;
                            white-space:nowrap;
                            text-overflow:ellipsis;
                            overflow:hidden;
                        }
                    }
                }
                tbody{
                    tr{
                        border-radius:10px;
                        box-shadow:0 0 0 1px #ebedf2;
                        &:hover{
                            background:#f8f9fb;
                        }
                        td{
                            text-align:center;
                            padding: 10px;
                            .info-box{
                                display:flex;
                                align-items:center;
                                column-gap:16px;
                                .cover-img{
                                    width:70px;
                                    height:70px;
                                    object-fit:cover;
                                    object-position:center;
                                    border-radius: 4px;
                                }
                                .info{
                                    display:flex;
                                    flex-direction:column;
                                    align-items:flex-start;
                                    width:100%;
                                    .info-title{
                                        color:#333;
                                        font-size:14px;
                                        font-weight:bold;
                                        display:flex;
                                        align-items:center;
                                        column-gap:8px;
                                        .title-tag{
                                            font-size: 12px;
                                            padding: 2px 8px;
                                            border-radius: 4px;
                                            &.platform{
                                                background: rgba(13, 153, 255, 0.1);
                                                color: #0d99ff;
                                            }
                                            &.custom{
                                                background: rgba(255, 89, 103, 0.1);
                                                color: #ff5967;
                                            }
                                        }
                                    }
                                    .info-key{
                                        color:#666;
                                        font-size:14px;
                                        margin-top: 8px;
                                    }
                                }
                            }
                            .type-tag{
                                font-size: 14px;
                                padding: 4px 12px;
                                border-radius: 4px;
                                &.platform{
                                    background: rgba(13, 153, 255, 0.1);
                                    color: #0d99ff;
                                }
                                &.custom{
                                    background: rgba(255, 89, 103, 0.1);
                                    color: #ff5967;
                                }
                            }
                            p{
                                color:#666;
                                font-size:14px;
                                line-height:24px;
                                span{
                                    color:#999;
                                }
                            }
                        }
                    }
                }
            }
            .history-page{
                margin-top:20px;
            }
        }
    }
}
</style>